import React, {PureComponent, Prop} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

export default class AbstractListerField extends PureComponent {
  static contextTypes = {
    sectionIndex: PropTypes.number,
    getScrollableContainer: PropTypes.func,
  };
}

export const styles = {};
